import { useFlowsSelector } from '../../../../../../common/src/utils/globalVariables';
import { HomeSearchAnswer } from '../../../input/advisory-flow-inputs/home/HomeInputComponent';
import useCurrentGroup from '../../../../hooks/useCurrentGroup';
import useMobileBreakpoints from '../../../../../../common/src/hooks/useMobileBreakpoints';

/**
 * Check if the home wrapper needs to be shown to the user
 */
const useDisplayHomeWrapper = (): boolean => {
  const answers = useFlowsSelector((state) => state.flows.answers);
  const { isLaptopL } = useMobileBreakpoints();
  const currentGroup = useCurrentGroup();
  const firstQuestionOfGroup = currentGroup?.questions[0];

  const homeSearch = answers.find(({ id }) => id === 'home.home_search');
  const homeSearchAnswer = homeSearch?.answer as HomeSearchAnswer;

  const firstQuestionOfGroupAnswer = answers.find(
    ({ id, index }) =>
      // eslint-disable-next-line eqeqeq
      id === firstQuestionOfGroup?.id && index == currentGroup?.index,
  );
  if (isLaptopL && !homeSearchAnswer?._local?.isNotFoundInAPI) {
    if (homeSearch?.index != null && currentGroup?.index == null) {
      return false;
    } else if (
      (currentGroup?.tag === 'HOME' ||
        (currentGroup?.tag === 'HOME_AND_FAMILY' &&
          currentGroup?.entity_key === 'BUILDING')) &&
      firstQuestionOfGroup?.rules.input_type !== 'HOME' &&
      firstQuestionOfGroup?.id !== 'home.amount_of_residences' &&
      currentGroup?.id !== 'residence.amount' &&
      currentGroup?.id !== 'residence.address'
    ) {
      // Should be shown on every HOME question except the initial home input question
      return true;
    } else if (
      firstQuestionOfGroupAnswer?.subViewHistory?.previous[
        firstQuestionOfGroupAnswer?.subViewHistory?.previous?.length - 1
      ] === 'houseDetail'
    ) {
      // Should be shown on the home input for the last subview
      return true;
    }
  }

  return false;
};

export default useDisplayHomeWrapper;
